import React from "react";
import { Form, Input } from "antd";
import { UserOutlined } from "@ant-design/icons";

const UserUserName = (props) => {
  // -------------------------- VAR --------------------------
  const { disabled } = props;
  // -------------------------- STATE --------------------------
  // -------------------------- REDUX --------------------------
  // -------------------------- EFFECT --------------------------
  // -------------------------- FUNCTION --------------------------
  // -------------------------- RENDER --------------------------
  // -------------------------- MAIN --------------------------
  return (
    <Form.Item
      name="username"
      label="User Name"
      rules={[
        {
          required: true,
          message: "Please input user name",
        },
        {
          pattern: /^[A-Za-z]+$/,
          message: "Alphabets only",
        },
      ]}
    >
      <Input showCount maxLength={30} placeholder="User Name" disabled={disabled} />
    </Form.Item>
  );
};

export default UserUserName;
